import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { GoogleMapsService } from '@shared/services/google.maps.service';

@Component({
  selector: 'app-ph-autocomplete-google-map',
  templateUrl: './ph-autocomplete-google-map.component.html',
  styleUrls: ['./ph-autocomplete-google-map.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PhAutocompleteGoogleMapComponent),
    },
  ],
})
export class PhAutocompleteGoogleMapComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() inputDefaultValue: string;
  autocompleteInput: string;
  placesLibrary: google.maps.PlacesLibrary;
  @Input() formControl: UntypedFormControl;

  @ViewChild('addresstext', { static: true }) addresstext: ElementRef;
  @Output() placeChanged: EventEmitter<google.maps.places.PlaceResult | null> = new EventEmitter();

  constructor(private googleMapsService: GoogleMapsService) {}

  ngOnInit(): void {
    if (this.inputDefaultValue) {
      this.autocompleteInput = this.inputDefaultValue;
    }
  }

  ngAfterViewInit(): void {
    this.googleMapsService.getPlacesLibrary().then((places) => {
      this.placesLibrary = places;
      this.getPlaceAutocomplete();
    });
  }

  private getPlaceAutocomplete(): void {
    const autocomplete = new this.placesLibrary.Autocomplete(this.addresstext.nativeElement);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place: google.maps.places.PlaceResult = autocomplete.getPlace();

      this.invokeEvent(place);
    });
  }

  private invokeEvent(place: google.maps.places.PlaceResult | null): void {
    this.placeChanged.emit(place);
  }

  modelChange() {
    if (!this.formControl?.value?.length) {
      this.placeChanged.emit(null);
    }
  }

  writeValue(obj: any): void {}
  registerOnChange(fn: any): void {}
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}
}
